import { render, staticRenderFns } from "./DsForm.vue?vue&type=template&id=2d9ac252&scoped=true"
import script from "./DsForm.vue?vue&type=script&lang=js"
export * from "./DsForm.vue?vue&type=script&lang=js"
import style0 from "./DsForm.vue?vue&type=style&index=0&id=2d9ac252&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9ac252",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d9ac252')) {
      api.createRecord('2d9ac252', component.options)
    } else {
      api.reload('2d9ac252', component.options)
    }
    module.hot.accept("./DsForm.vue?vue&type=template&id=2d9ac252&scoped=true", function () {
      api.rerender('2d9ac252', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/datasource/DsForm.vue"
export default component.exports